import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ClerkProvider } from '@clerk/clerk-react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// Initialize PostHog
posthog.init(
  process.env.REACT_APP_POSTHOG_KEY,
  {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false, // We'll handle pageviews manually for SPA
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <ClerkProvider publishableKey={clerkPubKey}>
        <App />
      </ClerkProvider>
    </PostHogProvider>
  </React.StrictMode>,
);
